import { useEffect, useState } from "react";
import { createClient } from "@supabase/supabase-js";

 const supabase = createClient("https://mobhixnpnainulcukljj.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1vYmhpeG5wbmFpbnVsY3VrbGpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTI3MDU3MTAsImV4cCI6MjAwODI4MTcxMH0.zM50dkPHCLc3-_u9BKaWCstN4-_kG3TDnd_EWfrEiLk");

 export default supabase;